'use client';
import React from 'react';

function TitleCommon({ title }: { title: string }) {
  return (
    <h1 className="uppercase text-[24px] max-lg:text-[18px] max-md:text-[16px] font-medium">
      {title}
    </h1>
  );
}

export default TitleCommon;
